import React from 'react';
import { useStyletron } from 'baseui';
import type { AttributeRowDescriptorT, TimelineActionsT } from '../../../types/frame-timeline-v4';
import { getSpanAtFrame } from '../../../utils/frame-timeline-v4';
import { AttributeSpanPopoverContent } from '../span-popover/attribute-span-popover-content';
import { SpanPopover } from '../span-popover/span-popover';
import { SpanPiece } from './span-piece';
import { SpanValueLabel } from './span-value-label';
type AttributeCellPropsT = {
  row: AttributeRowDescriptorT;
  frame: number;
  cellWidth: number;
  timelineActions?: TimelineActionsT;
  isSelected?: boolean;
};
export const AttributeCell = React.memo(function AttributeCell({
  row,
  frame,
  cellWidth,
  timelineActions,
  isSelected = false
}: AttributeCellPropsT) {
  const [, theme] = useStyletron();
  const actualFrame = frame - 1;
  const result = getSpanAtFrame(row.spans, actualFrame);
  if (!result) {
    return null;
  }
  const {
    span,
    position
  } = result;
  return <SpanPopover content={({
    close
  }) => <AttributeSpanPopoverContent attributeRowId={row.id} span={span} close={close} onUpdate={timelineActions?.onUpdateAnnotationAttribute} onDelete={timelineActions?.onDeleteAnnotationAttribute} />}>
      <SpanPiece position={position} clickable cellWidth={cellWidth} overrides={{
      fillColor: theme.colors.backgroundSecondary,
      borderColor: isSelected ? theme.colors.borderAccessible : 'transparent',
      handleColor: theme.colors.contentTertiary
    }}>
        <SpanValueLabel value={span.value} framesIntoSpan={actualFrame - span.start} position={position} cellWidth={cellWidth} />
      </SpanPiece>
    </SpanPopover>;
});